import type { FC } from 'react';
import React from 'react';
import { Box, Link, FlexRow, Col } from '@edreamsodigeo/prisma-design-system';
import {
  useTranslation,
  Desktop,
  Mobile,
  useTracking,
} from '@edreamsodigeo/frontend-core';
import { Text } from '@edreamsodigeo/prisma-design-system/deprecated';

import RibbonWithMessage from '@/components/FreeCancellation/RibbonWithMessage';

export interface FreeCancellationBannerMessageProps {
  showMoreInfo?: boolean;
  onMoreInfoClick?: () => void;
  labelPage: string;
}

interface FreeCancellationBannerMessageMoreInfoProps {
  onMoreInfoClick?: () => void;
  labelPage: string;
}

const FreeCancellationBannerMessageText: FC = () => {
  const { t } = useTranslation();
  return (
    <Text color="green.70" fontSize="body.1">
      {t('freeCancellation.summary.message')}
    </Text>
  );
};

const FreeCancellationBannerMessageMoreInfo: FC<
  FreeCancellationBannerMessageMoreInfoProps
> = ({ onMoreInfoClick, labelPage }) => {
  const { trackEvent } = useTracking();
  const { t } = useTranslation();
  const linkClick = (): void => {
    trackEvent({
      action: '24h-cancellation-msg',
      label: `24h-cancellation-msg_click_more-info_pag:${labelPage}`,
    });
    onMoreInfoClick?.();
  };
  return (
    <Box display="inline-block" marginLeft="base">
      <Link onClick={linkClick}>
        <Text fontSize="body.1">{t('freeCancellation.summary.more.info')}</Text>
      </Link>
    </Box>
  );
};

const FreeCancellationBannerMessage: FC<FreeCancellationBannerMessageProps> = ({
  showMoreInfo = false,
  onMoreInfoClick,
  labelPage,
}) => {
  return (
    <Box
      backgroundColor="green.20"
      paddingTop={{
        _: 'big',
        lg: 'base',
      }}
      paddingLeft={{
        _: 'base',
        lg: '0',
      }}
      paddingRight={{
        _: 'base',
        lg: 'big',
      }}
      paddingBottom={{
        _: 'base',
        lg: 'base',
      }}
    >
      <Desktop>
        <FlexRow gap="2" alignItems="center">
          <Col g>
            <RibbonWithMessage />
          </Col>
          <Col flexGrow={1}>
            <FreeCancellationBannerMessageText />
          </Col>
          <Col>
            {showMoreInfo && (
              <FreeCancellationBannerMessageMoreInfo
                onMoreInfoClick={onMoreInfoClick}
                labelPage={labelPage}
              />
            )}
          </Col>
        </FlexRow>
      </Desktop>
      <Mobile>
        <FreeCancellationBannerMessageText />
        {showMoreInfo && (
          <FreeCancellationBannerMessageMoreInfo
            onMoreInfoClick={onMoreInfoClick}
            labelPage={labelPage}
          />
        )}
      </Mobile>
    </Box>
  );
};

export default FreeCancellationBannerMessage;
